import { COLORS } from "../../utils/js/constants";

export default function salesPanelStyle(theme) {
    return {
        paper: {
            padding: theme.spacing(2),
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
        },
        appBarSpacer: theme.mixins.toolbar,
        content: {
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
            backgroundColor: 'black',
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
        containerManufacturer: {
            padding: theme.spacing(4),
            display: 'flex',
            overflow: 'auto',
            flexDirection: 'column',
            background: COLORS.grey,
        },
    }
}
